import React from 'react'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'
import { LabelOutlined, ViewList } from '@mui/icons-material'
import { useAppTranslations } from '../../../utils/hooks/useAppTranslations'

export type LocationsView = 'table' | 'chips'

type LocationsViewToggleProps = {
  view: LocationsView
  onChange: (view: LocationsView) => void
}

/** Switches the list between the table and the denser chips */
const LocationsViewToggle: React.FC<LocationsViewToggleProps> = ({ view, onChange }) => {
  const t = useAppTranslations()

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={view}
      onChange={(_, value: LocationsView | null) => value && onChange(value)}
      aria-label={t('adgroup.geoTargeting.panel.view')}
      sx={{ flexShrink: 0 }}
    >
      {/* A plain title: a Tooltip between the group and its buttons would break the group */}
      <ToggleButton
        value="table"
        aria-label={t('adgroup.geoTargeting.panel.viewTable')}
        title={t('adgroup.geoTargeting.panel.viewTable')}
        sx={{ px: 1 }}
      >
        <ViewList fontSize="small" />
      </ToggleButton>
      <ToggleButton
        value="chips"
        aria-label={t('adgroup.geoTargeting.panel.viewChips')}
        title={t('adgroup.geoTargeting.panel.viewChips')}
        sx={{ px: 1 }}
      >
        <LabelOutlined fontSize="small" />
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default LocationsViewToggle
